export default "__VITE_ASSET__DQhWLDa7__"